import React from 'react'
import {BaseHeroSection} from '../../../@shared/sections/hero/base'
import { Footer } from '../../../@shared/footers';
import NavbarMeganu from '../../../@shared/navigations/megamenu';
import { HeroSection } from '../listing/intro_primary';
import {SectionApp} from '../../../@shared/sections/hero/app'
import {HeroGreen} from '../../../@shared/sections/hero/green'

const HomePage = () => {

    return (
        <React.Fragment>
            <title>Home</title>
            <div className="homepage main ">
                <NavbarMeganu />
                <BaseHeroSection />
                <HeroSection />
                <Footer /> 
            </div>
        </React.Fragment>
    )
}

export default HomePage

 